const ORDER_LOOKUP_RESULT = (() => {
  const orderNumber = (order) => {
    const { mainIdentifier } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    const { orderNumberText } = ORDER_LOOKUP_RESULTS_CONFIG;
    const orderNumber = order.commercePlatform === 'shopify' && order.externalOrderNumber ?
      order.externalOrderNumber.toUpperCase() :
      order.uuidPrefix;
    return mainIdentifier({
      identifierText: orderNumberText.replace('[order_number]', orderNumber),
    });
  };

  const orderPlacedOn = (order) => {
    const { detailRow } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    const { placedOnText } = ORDER_LOOKUP_RESULTS_CONFIG;
    const row = detailRow();
    row.textContent = placedOnText.replace(
      '[placed_on]',
      DATE_TIME_FORMATS.PADDED_NUMERIC_DATE.format(new Date(order.orderPlacedAt)),
    );
    return row;
  };

  const orderStatus = (order) => {
    const { getOrderStatus } = ORDER_UTILS;
    const { detailRowWithLabel } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    const {
      canceledText,
      deliveredText,
      requestedText,
      shippedText,
      statusLabelText,
    } = ORDER_LOOKUP_RESULTS_CONFIG;

    let valueText;
    const orderStatus = getOrderStatus(order);
    switch (orderStatus) {
      case 'DELIVERED':
        valueText = deliveredText;
        break;
      case 'SHIPPED':
        valueText = shippedText;
        break;
      case 'CANCELED':
        valueText = canceledText;
        break;
      default:
        // The API should ensure that all orders returned to the client have been placed.
        valueText = requestedText;
        break;
    }

    return detailRowWithLabel({
      labelText: statusLabelText,
      valueText,
    });
  };

  const orderItemThumbnails = (order) => {
    const { thumbnails } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    return thumbnails({
      images: order.orderItems.map(({ inventoryItem }) => ({
        imgUrl: inventoryItem?.images[0]?.url,
        altText: `${inventoryItem?.catalogItem?.title} - ${inventoryItem?.color.displayName}`,
      })),
    });
  };

  const orderLookupResult = (order) => {
    const { resultContainer } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;

    const container = resultContainer({
      href: `${Shopify.routes.root}pages/order-status?orderUuid=${encodeURIComponent(order.uuid)}`,
    });

    container.append(
      orderNumber(order),
      orderPlacedOn(order),
      orderStatus(order),
      orderItemThumbnails(order),
    );

    return container;
  };

  return {
    orderLookupResult,
  };
})();
